<template>
    <section class="section section-lg section-shaped overflow-hidden my-0">
        <div class="shape shape-style-1 shape-default shape-skew">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container py-0 pb-lg">
            <div class="row justify-content-between align-items-center">
                <div class="col-lg-5 mb-5 mb-lg-0">
                    <h1 class="text-white font-weight-light">Overview of WIS</h1>
                    <p class="lead text-white mt-4">Take a look of our 2018-2019 year.</p>
                    <router-link to="/pastEvents"
                       class="btn btn-white mt-4">See more
                        </router-link>
                </div>
                <div class="col-lg-6 mb-lg-auto">
                    <div class="rounded shadow-lg overflow-hidden transform-perspective-right">
                        <b-carousel id="carousel1"
                                    controls
                                    indicators>
                            <!-- Text slides with image -->
                            <b-carousel-slide img-src="img/events/Slime1.JPG"></b-carousel-slide>
                            <b-carousel-slide img-src="img/events/Slime2.jpg"></b-carousel-slide>
                            <b-carousel-slide img-src="img/events/Glow2.JPG"></b-carousel-slide>
                            <b-carousel-slide img-src="img/events/Glow3.JPG"></b-carousel-slide>
                            <b-carousel-slide img-src="img/events/Glow4.png"></b-carousel-slide>
                            <b-carousel-slide img-src="img/events/Pasta1.png"></b-carousel-slide>  
                            <b-carousel-slide img-src="img/events/Pasta Challenge.jpg"></b-carousel-slide>
                            <b-carousel-slide img-src="img/events/Pasta2.jpg"></b-carousel-slide>
                            <b-carousel-slide img-src="img/events/Pasta3.png"></b-carousel-slide>
                            <b-carousel-slide img-src="img/events/Pasta4.png"></b-carousel-slide>
                            <b-carousel-slide img-src="img/events/Bread1.png"></b-carousel-slide>
                            <b-carousel-slide img-src="img/events/Bread2.png"></b-carousel-slide>
                            <b-carousel-slide img-src="img/events/Bread3.JPG"></b-carousel-slide>
                            <b-carousel-slide img-src="img/events/DNA1.JPG"></b-carousel-slide>
                            <b-carousel-slide img-src="img/events/DNA2.JPG"></b-carousel-slide>
                            <b-carousel-slide img-src="img/events/DNA3.JPG"></b-carousel-slide>
                            <b-carousel-slide img-src="img/events/DNA4.JPG"></b-carousel-slide>
                            <b-carousel-slide img-src="img/events/DNA5.JPG"></b-carousel-slide>


                        </b-carousel>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import BCarousel from "bootstrap-vue/es/components/carousel/carousel";
import BCarouselSlide from "bootstrap-vue/es/components/carousel/carousel-slide";

export default {
  components: {
    BCarousel,
    BCarouselSlide
  }
};
</script>
<style>
</style>
